import React from "react";

import InstoGroup from "../assets/insto-group.png";
import Amaran from "../assets/amaran-new-4.png";
import InstoWave from "../assets/wave-new.svg";
export default function GameEndModal({ showEndModal }) {
  return (
    <div
      className={`modal-wrapper ${showEndModal && "show"}`}
      id="game-end-modal"
    >
      <div className={`modal-overlay ${showEndModal && "show"}`}></div>
      <div className={`modal-content ${showEndModal && "show"}`}>
        <img src={InstoWave} className="wave-bg" alt="" />
        <h2>Selamat!!</h2>

        <div className="insto-content">
          <div>
            <p>
              Kamu berhasil menyelesaikan misi dan matamu kembali jernih!
              <br />
              <br />
              Temukan insto yang sesuai dengan keluhanmu
            </p>
            <div>
              <a href="https://insto.co.id/tentang-insto">Produk Insto</a>
              <a
                style={{ marginLeft: 20 }}
                href="#"
                onClick={() => window.location.reload()}
              >
                Coba Kembali
              </a>
            </div>
          </div>
          <div className="insto-group-img">
            <img src={Amaran} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}
